import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

/**
 * The daily scanned-receipts limit as a neutral −/+ stepper, exactly as
 * designed for the setup wizard. Shared between the wizard and the
 * loyalty-program edit page (replaces the old Material slider there).
 */
@Component({
  selector: 'app-daily-limit-stepper',
  templateUrl: './daily-limit-stepper.component.html',
  styleUrls: ['./daily-limit-stepper.component.scss'],
})
export class DailyLimitStepperComponent {
  /** The daily-limit form control (value clamped to [min, max] by the stepper). */
  @Input() control!: FormControl;
  @Input() min = 1;
  @Input() max = 20;
  /** Hide the label/hint when the host provides its own framing. */
  @Input() showLabel = true;
  @Input() showHint = true;

  public increment(): void {
    const value = Number(this.control.value) || 0;
    if (value < this.max) {
      this.control.setValue(value + 1);
      this.control.markAsDirty();
    }
  }

  public decrement(): void {
    const value = Number(this.control.value) || 0;
    if (value > this.min) {
      this.control.setValue(value - 1);
      this.control.markAsDirty();
    }
  }
}
